import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { upsertAddress, deleteAddress, getCurrentUser } from '../redux/slices/userSlice';

const AddressForm = () => {
    const dispatch = useDispatch();
    const { userInfo, loading } = useSelector((state) => state.user);

    const [isEditing, setIsEditing] = useState(false);
    const [address, setAddress] = useState({
        city: '',
        state: '',
        country: '',
        zip: '',
        addressLine: '',
    });

    useEffect(() => {
        if (userInfo?.address) {
            setAddress(userInfo.address);
        }
    }, [userInfo]);

    const handleChange = (e) => {
        setAddress({ ...address, [e.target.name]: e.target.value });
    };

    const handleSave = async () => {
        await dispatch(upsertAddress(address));
        dispatch(getCurrentUser());
        setIsEditing(false);
    };

    const handleDelete = async () => {
        await dispatch(deleteAddress());
        dispatch(getCurrentUser());
        setIsEditing(false);
    };

    return (
        <div className="bg-custom-white p-6 rounded-lg border-2 shadow-md">
            <div className="flex justify-between items-center w-full mb-4">
                <h2 className="text-xl font-semibold text-custom-blue">Address Details</h2>
                <button className="text-custom-blue" onClick={() => setIsEditing(!isEditing)}>
                    {isEditing ? 'Cancel' : 'Edit'}
                </button>
            </div>
            <hr className="bg-gray-300 border" />

            {isEditing ? (
                <div className="grid grid-cols-2 p-4 gap-4">
                    <div>
                        <label className="block text-sm text-gray-400">City<span className="text-red-500">*</span></label>
                        <input
                            name="city"
                            value={address.city}
                            onChange={handleChange}
                            placeholder="New Delhi"
                            className="w-full p-2 border rounded-md"
                        />
                    </div>
                    <div>
                        <label className="block text-sm text-gray-400">State<span className="text-red-500">*</span></label>
                        <input
                            name="state"
                            value={address.state}
                            onChange={handleChange}
                            placeholder="Delhi"
                            className="w-full p-2 border rounded-md"
                        />
                    </div>
                    <div>
                        <label className="block text-sm text-gray-400">Country<span className="text-red-500">*</span></label>
                        <input
                            name="country"
                            value={address.country}
                            onChange={handleChange}
                            placeholder="India"
                            className="w-full p-2 border rounded-md"
                        />
                    </div>
                    <div>
                        <label className="block text-sm text-gray-400">Zip Code<span className="text-red-500">*</span></label>
                        <input
                            name="zip"
                            value={address.zip}
                            onChange={handleChange}
                            placeholder="110019"
                            className="w-full p-2 border rounded-md"
                        />
                    </div>
                    <div className="col-span-2">
                        <label className="block text-sm text-gray-400">Address<span className="text-red-500">*</span></label>
                        <textarea
                            name="addressLine"
                            value={address.addressLine}
                            onChange={handleChange}
                            placeholder="123, Main Road, Civil Lines"
                            className="w-full p-2 border rounded-md"
                        />
                    </div>
                    <div className="col-span-2 flex justify-between">
                        <button
                            onClick={handleDelete}
                            className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-700 transition"
                        >
                            Delete
                        </button>
                        <button
                            onClick={handleSave}
                            className="bg-custom-blue text-custom-white px-4 py-2 rounded-md hover:bg-blue-800 transition"
                        >
                            Save
                        </button>
                    </div>
                </div>
            ) : (
                <div className="p-4 text-sm text-gray-400 space-y-2">
                    {userInfo?.address ? (
                        <>
                            <p><strong>City:</strong> {userInfo.address.city}</p>
                            <p><strong>State:</strong> {userInfo.address.state}</p>
                            <p><strong>Country:</strong> {userInfo.address.country}</p>
                            <p><strong>Zip:</strong> {userInfo.address.zip}</p>
                            <p><strong>Address:</strong> {userInfo.address.addressLine}</p>
                        </>
                    ) : (
                        <p>No address provided yet.</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default AddressForm;
